"use client";

import { Card, CardContent, CardHeader } from "@/components/ui/card";

/**
 * Component to display a placeholder for the indexing status.
 */
export function IndexingStatusLoading() {
  return (
    <Card className="animate-pulse">
      <CardHeader>
        <div className="h-6 bg-muted rounded-sm w-1/3" />
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="h-4 bg-muted rounded-sm w-1/2" />
          <div className="h-4 bg-muted rounded-sm w-2/3" />
        </div>
      </CardContent>
    </Card>
  );
}
